import { useState } from "react";

const ReadMoreDescription = ({
  text,
  maxLength = 80,
  className = "tb-data",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text || text === "NA") {
    return <span className={className}>NA</span>;
  }

  const shouldTruncate = text.length > maxLength;
  const displayText = isExpanded ? text : text.slice(0, maxLength);

  return (
    <span className={className}>
      {displayText}
      {shouldTruncate && !isExpanded && "..."}
      {shouldTruncate && (
        <>
          <br />
          <span
            className="link underline"
            style={{
              color: "#cd0909",
              cursor: "pointer",
              fontWeight: "bold",
            }}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? "Read Less" : "Read More"}
          </span>
        </>
      )}
    </span>
  );
};

export default ReadMoreDescription;
